import React, {useRef, useState} from "react";
import {Space, Form, Row, Col, message, Button} from "antd";
import Child from "./Child";

const Ref = () => {
  const childRef = useRef<any>();
  const [dataFromChild, setDataFromChild] = useState<any>();
  return (
    <div className="parent">
      <div className="container">
        <div style={{fontWeight: 600, textAlign: "center"}}>Parent</div>
        <Button
          onClick={() => {
            const data = childRef.current?.getData();
            setDataFromChild(data);
          }}
        >
          Dữ liệu từ component con: {dataFromChild?.name}
        </Button>
        <Child ref={childRef}></Child>
      </div>
    </div>
  );
};
export default Ref;
